import script from "./AddNewUser.vue?vue&type=script&setup=true&lang=js"
export * from "./AddNewUser.vue?vue&type=script&setup=true&lang=js"

import "./AddNewUser.vue?vue&type=style&index=0&id=4400e52c&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4400e52c"]])

export default __exports__